import { Col, Row } from "reactstrap"
import { URL } from "../../../../api"
import { LineCount } from "../../../../utilities/line-count"

const OurBussinessPage = ({ data, lang }) => {
    return (
        <div className="solutions-container">
            <div className="textJustifyCenter partner-text mt-5">
                <div className="f24 d-flex align-items-center justify-content-center className='blueText'">
                    <span className='color10 f32 fw500 mb-5'>{data?.description[lang]}</span>
                </div>
            </div>
            <Row className='d-flex justify-content-center align-items-center'>
                {
                    (data?.modules ? [...data?.modules] : [])
                        .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                        .map((item, index) => {
                            return (
                                <Col xs={12} sm={12} md={LineCount(data?.lineCount)} lg={LineCount(data?.lineCount)} xl={LineCount(data?.lineCount)} key={index} className="mb-4">
                                    <div className="partner-item">
                                        <img src={`${URL}${item?.files[0]}`} alt='' loading="lazy" />
                                    </div>
                                </Col>
                            )
                        })
                }
            </Row>
        </div>
    )
}

export default OurBussinessPage
